export const REQUIRES_APPROVAL_STATUS = "requires approval";
